import { Button } from '@pulse-web-ui/button';
import { media, mixins, styled, typography } from '@pulse-web-ui/theme';

export const SupportBlockContent = styled.div`
  box-sizing: border-box;
  padding-top: 40px;

  ${media.desktop} {
    padding-top: 32px;
  }
`;

export const SupportBlockTitle = styled.h3`
  ${typography.medium18};
  line-height: 26px;
  margin-bottom: 24px;
`;

export const SupportButtonsWrapper = styled.div`
  ${mixins.flex({
    gap: 12,
    horizontal: false,
  })}

  ${media.desktop} {
    ${mixins.flex({ gap: 12 })}
  }
`;

export const SupportButton = styled(Button)`
  height: 48px;
  padding: 8px 32px;
`;
